import { HTTP_INTERCEPTORS } from '@angular/common/http';
import {
  CUSTOM_ELEMENTS_SCHEMA,
  DoBootstrap,
  Injector,
  NgModule,
} from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { createCustomElement } from '@angular/elements';

// Modules
import { BrowserModule } from '@angular/platform-browser';
import { CoreModule } from '@core/core.module';

// Services
import { NotificationMfeService } from '@core/service/notification-mfe.service';

// Components
import { MncNotificationComponent } from './mnc-notification.component';
import { EmptyComponent } from '@shared/empty/empty.component';

import { environment } from '@env/environment';
import { RouteInterceptor, ShellService, TokenInterceptor } from '@mynexus/mfe-core';
import { API_BASE_URL } from '@core/constants';
import { providePrimeNG } from 'primeng/config';
import { Carelon, CSS_LAYERS_ORDER } from '@mynexus/theme';

@NgModule({
  declarations: [
    MncNotificationComponent,
    EmptyComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CoreModule,
  ],
  exports: [
    ...environment.modules,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RouteInterceptor,
      multi: true
    },
    {
      provide: API_BASE_URL,
      useFactory: (shellService: ShellService) => shellService.getBaseUrlFor('NotificationGateway'),
      deps: [ShellService]
    },
    providePrimeNG({
      ripple: false,
      theme: {
        preset: Carelon,
        options: {
          darkModeSelector: false,
          cssLayer: {
            name: 'primeng',
            order: CSS_LAYERS_ORDER
          }
        },
      }
    }),
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class MncNotificationModule implements DoBootstrap {
  constructor(
    private injector: Injector,
    private shellService: ShellService,
    private mfeService: NotificationMfeService
  ) {
  }

  ngDoBootstrap(): void {
    this.registerCustomElement('mnc-notification', MncNotificationComponent);

    this.shellService.registerMfeService('mnc-notification', this.mfeService);
  }

  private registerCustomElement(name: string, component: any) {
    if (customElements.get(name)) return;
    customElements.define(
      name,
      createCustomElement<any>(component, {injector: this.injector}));
  }
}
